import { useContext, useEffect } from 'react';
import useScript from '../ui/hooks/useScript';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import useIsDev from '../ui/hooks/useIsDev';

export function InretrnScript() {
  const storeToken = 'Ojp1bHRpbWF0ZW5vcmRpYw==';
  const { selectedChannel } = useContext(ChannelContext);
  const langData = selectedChannel.language.culture.split('-');
  const lang = langData?.length > 1 ? langData[1].toLowerCase() : '';
  const isDev = useIsDev();
  const status = useScript(
    `https://${isDev ? 'uat-' : ''}returnsportal.inretrn.com/inretrn.js`
  );

  useEffect(() => {
    if (status === 'ready') {
      if (typeof window !== 'undefined') {
        const m = window.location.href.match(/#(.)+$/);
        let s = storeToken;
        if (m && m.length > 0) {
          s = m[0].substr(1);
        }
        console.log('Inreturn lang', lang);
        console.log('Inreturn redirectUrl', selectedChannel.url);
        window.Inretrn.init({
          drToken: s,
          languageCode: lang,
          redirectUrl: selectedChannel.url
        });
      }
    }
  }, [status, lang, selectedChannel]);

  return null;
}
